import { Button } from "@/components/ui/button";

interface SelectionInfoProps {
  selectedCount: number;
  selectAllFiltered: boolean;
  totalFiltered: number;
  onClearSelection: () => void;
  onSelectAllFiltered: () => void;
}

export function SelectionInfo({
  selectedCount,
  selectAllFiltered,
  totalFiltered,
  onClearSelection,
  onSelectAllFiltered,
}: SelectionInfoProps) {
  if (selectedCount === 0 && !selectAllFiltered) return null;

  return (
    <div className="flex items-center gap-4 py-2 text-sm">
      <span className="text-gray-600">
        {selectAllFiltered
          ? `Todas as ${totalFiltered.toLocaleString("pt-BR")} filtradas selecionadas`
          : `${selectedCount.toLocaleString("pt-BR")} selecionada${selectedCount !== 1 ? "s" : ""}`}
      </span>
      {!selectAllFiltered && totalFiltered > selectedCount && (
        <Button
          variant="link"
          size="sm"
          className="h-auto p-0 text-sm"
          onClick={onSelectAllFiltered}
        >
          Selecionar todas as {totalFiltered.toLocaleString("pt-BR")} filtradas
        </Button>
      )}
      <Button
        variant="link"
        size="sm"
        className="h-auto p-0 text-sm"
        onClick={onClearSelection}
      >
        Limpar selecao
      </Button>
    </div>
  );
}
